import {
  ChangeDetectionStrategy,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  Input,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@loup-transload-ui-app/common-pipes';

@Component({
  selector: 'lib-not-authorized',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  templateUrl: './not-authorized.component.html',
  styleUrls: ['./not-authorized.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotAuthorizedComponent {
  /** Optional overrides if you want to customize from a parent route */
  @Input() title = 'Not-Authorized';
  @Input() message = 'You do not have access to this functionality.';
  @Input() help =
    'If you believe you received this in error, please contact support.';
  /** Optional support link or mailto */
  @Input() supportHref: string | null = null;
  @Input() supportText = 'Contact support';

  gotoHome() {
    const host = location.hostname;
    const protocol = location.protocol;
    const base = `${protocol}//${host}`;
    const url = `${base}/slt/apps/master/secure/#/search/location/LOCATION_TRANSLOAD_FACILITY`;
    window.location.assign(url);
  }
}
